import { Link } from "react-router-dom";
import { PUBLIC } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

const statusMap = {
  in_renovation: { label: "In Renovation", dot: "bg-ruby" },
  coming_soon: { label: "Coming Soon", dot: "bg-bronze" },
  completed: { label: "Completed", dot: "bg-ink-700" },
  sold: { label: "Sold", dot: "bg-ruby-deep" },
};

export default function PropertyCard({ p }) {
  const status = statusMap[p.public_status] || { label: p.public_status || "Project", dot: "bg-ink-100" };
  const img = p.public_main_image || (p.images && p.images[0]) || "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=85";
  return (
    <article data-testid={PUBLIC.propertyCard(p.id)} className="group flex flex-col h-full">
      <Link to={`/properties/${p.id}`} className="block relative aspect-[4/5] overflow-hidden">
        <img
          src={img}
          alt={p.public_project_name || p.title}
          className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-[1.05]"
        />
        <div className="absolute top-5 left-5 flex items-center gap-2 bg-cream-100/95 backdrop-blur px-3 py-1.5">
          <span className={`w-1.5 h-1.5 rounded-full ${status.dot}`} />
          <span className="text-[0.65rem] font-mono uppercase tracking-[0.18em] text-ink-700">{status.label}</span>
        </div>
      </Link>
      <div className="pt-8 flex flex-col flex-1">
        <p className="label-mono-mute">{p.city || p.county || p.country}</p>
        <Link to={`/properties/${p.id}`} className="block group/title">
          <h3 className="mt-3 serif-light text-3xl lg:text-[2.25rem] text-ink-700 leading-[1.05] group-hover/title:text-ruby transition-colors">
            {p.public_project_name || p.title}
          </h3>
        </Link>
        <p className="mt-4 text-ink-100 text-sm leading-[1.7] line-clamp-2 flex-1">
          {p.public_short_description || p.description || "A signature Rubys.Group transformation."}
        </p>
        <Link to={`/properties/${p.id}`} className="btn-link mt-6 self-start">
          View project <ArrowUpRight size={13} />
        </Link>
      </div>
    </article>
  );
}
